export enum SegmentedEn {
  myTicket = 'my-ticket',
  handle = 'handle',
  officeHandle = 'office-handle',
  hrConfirm = 'hr-confirm'
}
